import React, { useContext, useState } from 'react';
import { Container, Typography } from '@mui/material';
import { RemoteControlContext } from '../../ContextProvider';
import AlertDrawer from '../../components/AlertDrawer';
import { sortEventsByDate } from '../../helpers/sortEventsByDate';
import { Section } from '../../components/Section';

const NowPlaying = ({ nowPlaying, handleEventSubClick }) => {
    if (nowPlaying.length) {
        return (
            <Section
              title='On Screen Now'
              events={nowPlaying}
              handleEventSubClick={handleEventSubClick}
              liveNowEvent
        />
        );
    }

    return (
        <>
            <Typography className='no-event-on-screen' variant='h2'>On Screen Now</Typography>
            <Typography variant='p'>Select an event to play now.<br /><br /> </Typography>
        </>
    );
};

export default function Home () {
    const [drawerAlert, setDrawerAlert] = useState(false);
    const { liveEvents, nowPlaying, handleEventSubClick } = useContext(RemoteControlContext);

    const happeningNow = liveEvents.filter(event => event.status === 'LIVE');
    const futureEvents = liveEvents.filter(event => event.status === 'SCHEDULED' || event.status === 'COMING');

    const showOverlapDrawer = (e, drawerMessage) => {
        e.stopPropagation();
        setDrawerAlert(drawerMessage);
    };

    return (
        <Container variant='events'>
            <AlertDrawer drawerAlert={drawerAlert} closeDrawer={() => setDrawerAlert(false)} title='Overlapping Events' />
            {happeningNow.length > 0 && (
                <>
                    <NowPlaying nowPlaying={nowPlaying} handleEventSubClick={handleEventSubClick} />

                    <Section
                      events={happeningNow}
                      title='Other Live Events'
                      subtitle='Change the event on your screen.'
                      handleEventSubClick={(event) => handleEventSubClick(event, true)}
                    />
                </>
            )}
            {futureEvents.length === 0
                ? (
                    <>
                        <Typography variant='h2'>Upcoming Events</Typography>
                        <Typography variant='p'>
                            <Typography variant='p-strong'>There are no events at the moment.</Typography>
                            <br />
                            Please check back for future updates.
                        </Typography>
                    </>)
                : (
                    <FutureEvents
                      futureEvents={futureEvents}
                      handleEventSubClick={handleEventSubClick}
                      showOverlapDrawer={showOverlapDrawer}
                    />
                )}
        </Container>
    );
}

const FutureEvents = ({ futureEvents = [], handleEventSubClick, showOverlapDrawer }) => {
    const futureEventsSorted = sortEventsByDate(futureEvents);

    return (
        <>
            {futureEventsSorted.map(({ title, events }) =>
                <div key={title}>
                    <Section
                      title={title} titleVariant='date-title'
                      events={events}
                      handleEventSubClick={handleEventSubClick}
                      futureEvent
                      handleOverlapIconClick={showOverlapDrawer}
                      otherEvents={futureEvents.filter(event => event.subscribed)}
                    />
                </div>
            )}
        </>
    );
};
